<div class="down-footer__main">
  <a class="down-footer__logo" routerLink="/">
    <img
      src="assets/logo.svg"
      width="38"
      height="38"
      alt="videosense.pro logo"
    />
  </a>
  <div class="down-footer__links">
    <a
      href="https://find-and-update.company-information.service.gov.uk/company/15921339"
      target="_blank"
    >
      &copy; 2025 <span>—</span> VIDEO SENSE LTD <span>—</span> 15921339
    </a>
    <a routerLink="/terms-of-use">Terms of Use</a>
  </div>
</div>
